import type { ReactElement } from "react";
import { buildScreens } from "./registry-build";
import { deploy_knowledgeScreens } from "./registry-deploy-knowledge";
import { engageScreens } from "./registry-engage";
import { guideScreens } from "./registry-guide";
import { workspaceScreens } from "./registry-workspace";

/**
 * Real screens replace their permission-gated placeholder route when registered here.
 * Each feature group owns one registry file so parallel work never edits the route table.
 */
export const featureScreens: Readonly<Record<string, ReactElement>> = {
  ...buildScreens,
  ...deploy_knowledgeScreens,
  ...workspaceScreens,
  ...engageScreens,
  ...guideScreens,
};
